import classNames from 'classnames';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { preferenceActions } from '../../../actions';
import useDispatch from '../../../hooks/useDispatch';
import useSelector from '../../../hooks/useSelector';
import {
  DL_SWITCH_CLASS_NAME,
  DL_SWITCH_LEAD_CLASS_NAME,
  DL_SWITCH_LINE_WRAPPER_CLASS_NAME,
} from '../PriceViewer';

const MASwitch: React.FC<{
  wrapAnalytics: (dataKey: string, callback: () => void) => () => void;
}> = ({ wrapAnalytics }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { showMA, MAType, MAIntervals } = useSelector(
    state => state.preference
  );
  return (
    <>
      <div className={DL_SWITCH_LINE_WRAPPER_CLASS_NAME}>
        {['SMA', 'EMA'].map(type => (
          <div
            key={type}
            className={classNames(DL_SWITCH_CLASS_NAME, {
              [DL_SWITCH_LEAD_CLASS_NAME]: type === 'SMA', // first button is lead
              checked: showMA && MAType === type.toLowerCase(),
            })}
            onClick={wrapAnalytics(type, () => {
              if (MAType === type.toLowerCase()) {
                dispatch(preferenceActions.setPriceViewerMA(!showMA));
              } else {
                dispatch(preferenceActions.setPriceViewerMA(true));
              }
              dispatch(
                preferenceActions.setPriceViewerMAType(type.toLowerCase())
              );
              // Disable bollinger band when SMA is on
              if (!showMA) {
                dispatch(preferenceActions.setPriceViewerBollingerBand(false));
              }
            })}
          >
            {type}
          </div>
        ))}
        {[10, 20, 50, 250].map(interval => (
          <div
            key={interval}
            className={
              DL_SWITCH_CLASS_NAME +
              (MAIntervals.includes(interval) ? ' checked' : '') +
              (showMA ? '' : ' disabled')
            }
            onClick={wrapAnalytics(`ma-${interval}`, () => {
              let newIntervals = [...MAIntervals];
              if (MAIntervals.includes(interval)) {
                newIntervals = newIntervals.filter(v => v !== interval);
              } else {
                newIntervals = [...newIntervals, interval];
                newIntervals.sort((a, b) => a - b);
              }
              dispatch(
                preferenceActions.setPriceViewerMAInterval(newIntervals)
              );
            })}
          >{`${interval}${t('d')}`}</div>
        ))}{' '}
      </div>
    </>
  );
};

export default MASwitch;
